import { useState } from "react";

const useCopyWithFeedback = (resetDelay = 1400) => {
  const [copied, setCopied] = useState(null);

  const handleCopy = (id, text) => {
    if (!navigator?.clipboard) return;
    navigator.clipboard.writeText(text).then(() => {
      setCopied(id);
      setTimeout(() => setCopied(null), resetDelay);
    });
  };

  return { copied, handleCopy };
};

export default useCopyWithFeedback;
